<ng-container *ngIf="(inventeringarError$|async) && !(loadingInventeringar$|async) && displayError" #errorContent>
  <app-error-message></app-error-message>
</ng-container>
<ng-container *ngIf="!(inventeringarError$|async) && !(loadingInventeringar$|async)" #projectedContent>
  <ng-content></ng-content>
</ng-container>
<ng-container *ngIf="(loadingInventeringar$|async) && displayLoader" #loadingContent>
  <app-loader></app-loader>
</ng-container>
